import { DetailsTableDialog } from "../../../../../shared/components/dialogs/details-table-dialog/details-table-dialog.view";
import { RenderDateMDY } from "../../../../../shared/scripts/table-functions";
import { Contract } from "../../scripts/contracts.entities";

var Highcharts = require('highcharts/highcharts');

export class ContractSummaryTab {

    dataTable: any;
    achievementChart: any;
    pieChart: any;

    dataRows: ContractSummaryTableRow[];
    detailsTableModal: DetailsTableDialog;

    //public static statusesOfInterest: string[] = ["Requested", "Draft", "Negotiation", "Signature", "Fully Executed", "On Hold", "Withdrawn"];
    public static statusesOfInterest: string[] = ["Requested", "Draft", "Negotiation", "Signature", "Fully Executed"];

    constructor() {

        this.initializeTable();
        this.initializeAchievementChart();
        this.initializePieChart();
        this.initiatlizeButtons();
        //this.updateContent(contracts);
    }

    updateContent(tableContracts: Contract[], chartContracts: Contract[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(this.getTableContent(tableContracts)).draw();

        this.setAchievementChartContent(chartContracts);
    }

    private getTableContent(contracts: Contract[]): ContractSummaryTableRow[] {

        let rowHash: Map<string, ContractSummaryTableRow> = new Map<string, ContractSummaryTableRow>();
        let overallRow: ContractSummaryTableRow = new ContractSummaryTableRow();

        overallRow.ContractType = "Overall";

        contracts = contracts.filter((contract: Contract) => ContractSummaryTab.statusesOfInterest.includes(contract.StatusGroup));
        contracts.forEach((contract: Contract) => {

            let row: ContractSummaryTableRow;
            if (rowHash.has(contract.ContractType)) { row = rowHash.get(contract.ContractType); }
            else { row = new ContractSummaryTableRow(); row.ContractType = contract.ContractType; }

            row.addValue(contract);
            overallRow.addValue(contract);

            rowHash.set(row.ContractType, row);
        });

        rowHash.set("Overall", overallRow);

        this.dataRows = Array.from(rowHash.values());
        this.dataRows = this.dataRows.sort((a: ContractSummaryTableRow, b: ContractSummaryTableRow) => {
            if (a.ContractType == "Overall") return 1;
            else if (b.ContractType == "Overall") return -1;
            else return a.ContractType.localeCompare(b.ContractType);
        });
        this.dataRows.forEach((a: ContractSummaryTableRow, index: number) => {
            a.OrderBy = index
            a.setDisplayValues();
        });

        this.setPieChartContent(rowHash.get("Overall"));

        return this.dataRows;
    }

    private setAchievementChartContent(contracts: Contract[]) {

        //console.log(contracts);

        //const start = new Date().getTime();
        contracts = contracts.filter((contract: Contract) => ContractSummaryTab.statusesOfInterest.includes(contract.StatusGroup));

        //get unique dates
        let uniqueDates: number[] = [];
        let dateTimes: number[] = [];
        contracts.forEach((contract: Contract) => {
            contract.HistoryUniqueDates.forEach((d: number) => {
                if (!dateTimes.includes(d)) {
                    dateTimes.push(d);
                    uniqueDates.push(d);
                }
            });
        });
        uniqueDates.sort((a: number, b: number) => a - b);

        //let chartDataLabels: string[] = ['Fully Executed', 'Signature', 'Negotiation', 'Draft', 'Requested'];
        //let chartSeriesColors: string[] = ['#0093af', '#5b9bd5', '#4c4c4c', '#f2ba49', '#de4846'];
        let chartDataLabels: string[] = ['Fully Executed', 'Signature', 'Negotiation'];
        let chartSeriesColors: string[] = ['#0093af', '#5b9bd5', '#4c4c4c'];
        let chartData: ContractSummaryChartDataSeries[] = [];
        let currentCounts: number[] = [ 0, 0, 0 ];

        chartDataLabels.map((label: string, index: number) => {
            chartData.push(new ContractSummaryChartDataSeries(label, chartSeriesColors[index]));
        });
                
        uniqueDates.forEach((date: number) => {
            currentCounts = [ 0, 0, 0 ];
            contracts.forEach((contract: Contract) => {

                let statusOnDay: string = contract.getContractStatusOnDate(date);

                for (let i: number = 0; i < chartDataLabels.length; ++i) {
                    if (statusOnDay == chartDataLabels[i]) {
                        currentCounts[i]++;
                    }
                }
            });

            currentCounts.forEach((count: number, index: number) => {
                chartData[index].data.push( [date, count] );
            });
        });

        //const duration = new Date().getTime() - start;
        //console.log(uniqueDates);
        //console.log(chartData);
        //console.log(`contracts chart = ${duration / 1000}s`);

        //console.log(this.achievementChart);

        chartData.forEach((data: ContractSummaryChartDataSeries, index: number) => {
            this.achievementChart.series[index].setData(data.data);
        });
        $('#contract-count-label').html(contracts.length + "");
    }

    private setPieChartContent(overallCounts: ContractSummaryTableRow): void {
        let chartData: any[] = [];
        chartData.push({ name: "Requested", y: overallCounts.Values[0], color: '#de4846' });
        chartData.push({ name: "Draft", y: overallCounts.Values[1], color: '#f2ba49' });
        chartData.push({ name: "Negotiation", y: overallCounts.Values[2], color: '#673284' });
        chartData.push({ name: "Signature", y: overallCounts.Values[3], color: '#5b9bd5' });
        chartData.push({ name: "Fully Executed", y: overallCounts.Values[4], color: '#0093af' });

        //console.log(chartData);
        this.pieChart.series[0].setData(chartData);
    }

    private initializeTable(): void {
        this.dataTable = $('#contracts-summary-table').DataTable({
            //"dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            searching: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            ordering: false,
            columns: [
                { data: "ContractType", title: "Contract Type", className: "text-left font-size12 nowrap" },
                { data: { _: "DisplayValues.0", sort: "Values.0" }, title: "Requested", className: "text-center font-size12 nowrap" },
                { data: { _: "DisplayValues.1", sort: "Values.1" }, title: "Draft", className: "text-center font-size12 nowrap" },
                { data: { _: "DisplayValues.2", sort: "Values.2" }, title: "Negotiation", className: "text-center font-size12 nowrap" },
                { data: { _: "DisplayValues.3", sort: "Values.3" }, title: "Signature", className: "text-center font-size12 nowrap" },
                { data: { _: "DisplayValues.4", sort: "Values.4" }, title: "Fully Executed", className: "text-center font-size12 nowrap" },
                { data: { _: "DisplayValues.5", sort: "Values.5" }, title: "Overall", className: "overall-data text-center font-size12 nowrap" },
                { data: "OrderBy", visible: false },
            ],
            columnDefs: [
                { target: 0, orderable: false }
            ],
            order: [[7, 'asc']],
            createdRow: (row, data, dataIndex) => {
                if (data["ContractType"] == "Overall") { $(row).addClass("overall-data"); }
            }
        });

        this.detailsTableModal = new DetailsTableDialog([
            { data: "PrimeContract", title: "Prime Contract", className: "prime-contract text-center font-size12 nowrap", width: '100px' },
            { data: { _: "ContractNumber", sort: "ContractNumber" }, title: "Contract ID", className: "site-id text-center font-size12 nowrap", width: '100px' },
            { data: { _: "ContractNameDisplay", sort: "ContractName" }, title: "Contract Name", className: "text-left font-size12" },
            { data: { _: "StatusDisplay", sort: "Status" }, title: "Status", className: "text-left font-size12" },
            { data: "DateLastStatusStart", title: "Last Status Change", className: "completion-date text-left font-size12 nowrap", render: RenderDateMDY },
        ], [[4, 'desc']]);
    }

    private initializeAchievementChart(): void {
        this.achievementChart = Highcharts.chart('contracts-summary-chart', {
            chart: {
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'bottom',
                        x: -50,
                        y: 50
                    },
                    relativeTo: 'chart'
                }
            },
            tooltip: {
                //xDateFormat: '%m/%d/%Y',
                xDateFormat: '%d%b%Y',
                shared: true,
                split: false,
                enabled: true,
                formatter: function (tooltip) {
                    //to make points appear in order in tooltip
                    this.points.reverse();
                    return tooltip.defaultFormatter.call(this, tooltip);
                },
            },
            title: {
                text: ''
            },
            credits: { enabled: false },
            plotOptions: {
                line: {
                    marker: { enabled: false }
                }
            },
            yAxis: {
                title: { text: 'Contract Count' }
            },
            xAxis: {
                type: 'datetime',
                crosshair: {
                    snap: true
                },
                labels: {
                    formatter: function () {
                        //return Highcharts.dateFormat('%m/%d/%y', this.value);
                        return Highcharts.dateFormat('%d%b%y', this.value);
                    }
                },
                events: {
                    afterSetExtremes: function (event) {
                        if (event.max < event.dataMax || event.min > event.dataMin) {
                            $("#contracts-summary-chart-resetZoom").show();

                        }
                        else {
                            $("#contracts-summary-chart-resetZoom").hide();
                        }
                    }
                }
            },
            legend: {
                enabled: true,
                reversed: true,
                margin: 30,
                align: 'right',
                verticalAlign: 'middle',
                layout: 'vertical'
            },
            series: [ //need empty to replace when data loaded
                { name: 'Fully Executed', data: [], color: '#0093af' },
                { name: 'Signature', data: [], color: '#5b9bd5' },
                { name: 'Negotiation', data: [], color: '#673284' },
                //{ name: 'Draft', data: [], color: '#f2ba49' },
                //{ name: 'Requested', data: [], color: '#de4846' },
            ] 
        });
    }

    private initializePieChart(): void {
        this.pieChart = Highcharts.chart('contracts-summary-pie-chart', {
            chart: {
                //plotBackgroundColor: null,
                //plotBorderWidth: null,
                //plotShadow: false,
                type: 'pie',
                styledMode: false
            },
            title: {
                text: undefined
            },
            tooltip: {
                pointFormat: '<b>{point.percentage:.1f}%</b>'
            },
            credits: { enabled: false },
            //accessibility: {
            //    point: {
            //        valueSuffix: '%'
            //    }
            //},
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        format: '<b>{point.percentage:.1f} %</b>'
                    },
                    showInLegend: true
                }
            },
            series: [{
                colorByPoint: false,
                color: 'red',
                data: []
            }]
        });
    }

    showDetailTableModal(id: any, type: string): void {

        for (let i = 0; i < this.dataRows.length; ++i) {
            if (this.dataRows[i].ContractType == id) {
                let data: any[] = this.dataRows[i].getSelectedData(type);
                this.detailsTableModal.setData(data);
                this.detailsTableModal.show(this.dataRows[i].ContractType + " (n = " + data.length + ")");
                break;
            }
        }
    }

    private initiatlizeButtons(): void {
        $("#contracts-summary-chart-resetZoom").hide();

        $("#contracts-summary-chart-resetZoom").click(() => {
            this.achievementChart.zoomOut();
        })
    }
}

export class ContractSummaryTableRow {
    ContractType: string;
    OrderBy: number = -1;

    Values: number[] = [0,0,0,0,0,0];
    DisplayValues: string[] = [];
    Contracts: Contract[][];

    constructor() { this.Contracts = [[], [], [], [], []]; }

    addValue(contract: Contract): void {

        let index: number = -1;
        switch (contract.StatusGroup) {
            case "Requested": { index = 0; break; }
            case "Draft": { index = 1; break; }
            case "Negotiation": { index = 2; break; }
            case "Signature": { index = 3; break; }
            case "Fully Executed": { index = 4; break; }
        }

        if (index >= 0) {
            this.Values[index] += 1;
            this.Contracts[index].push(contract);

            this.Values[5] += 1; //overall
        }
    }

    setDisplayValues(): void {
        this.DisplayValues[0] = this.getDisplayValue(this.Values[0], "requested");
        this.DisplayValues[1] = this.getDisplayValue(this.Values[1], "draft");
        this.DisplayValues[2] = this.getDisplayValue(this.Values[2], "negotiation");
        this.DisplayValues[3] = this.getDisplayValue(this.Values[3], "signature");
        this.DisplayValues[4] = this.getDisplayValue(this.Values[4], "fully-executed");
        this.DisplayValues[5] = this.getDisplayValue(this.Values[5], "overall");
    }

    private getDisplayValue(count: number, type: string): string {
        return "<span class='underline-hover' onclick='page.showDetailTableModal(\"" + this.ContractType + "\", \"" + type + "\")'>" + count + "</span>";
    }

    getSelectedData(type: string): any[] {
        if (type == "requested") return this.Contracts[0];
        else if (type == "draft") return this.Contracts[1];
        else if (type == "negotiation") return this.Contracts[2];
        else if (type == "signature") return this.Contracts[3];
        else if (type == "fully-executed") return this.Contracts[4];
        else if (type == "overall") return [...this.Contracts[0], ...this.Contracts[1], ...this.Contracts[2], ...this.Contracts[3], ...this.Contracts[4]];
    }
}

export class ContractSummaryChartDataSeries {
    name: string;
    color: string;
    data: any[]; //Date.getTime(), count

    constructor(name: string, color: string) {
        this.name = name;
        this.color = color;
        this.data = [];
    }
}